var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form',{staticClass:"box-cart-express",on:{"submit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }